import SplashScreen from './components/SplashScreen/SplashScreen.jsx';
import SplashScreenSpinner from './components/SplashScreenSpinner/SplashScreenSpinner.jsx';

const SplashScreenPlugin = () => ({
  components: {
    SplashScreen,
    SplashScreenSpinner,
  },
});

export default SplashScreenPlugin;
